<template>
  <div class="team section-box">
    <SectionTitle zh="核心团队" en="CORE MEMBERS"></SectionTitle>
    <div class="team-wrap container">
      <div class="item">
        <span class="name">{{$t('about.teamN1')}}</span>
        <img src="~@/assets/image/about/team1.png">
        <div class="details">
          {{$t('about.team1D1')}}<span>{{$t('about.team1D2')}}</span>{{$t('about.team1D3')}}<span>{{$t('about.team1D4')}}</span>{{$t('about.team1D5')}}<span>{{$t('about.team1D6')}}</span>{{$t('about.team1D7')}}<span>{{$t('about.team1D8')}}</span>{{$t('about.team1D9')}}
        </div>
      </div>
      <div class="item">
        <span class="name">{{$t('about.teamN2')}}</span>
        <img src="~@/assets/image/about/team2.png">
        <div class="details">
          {{$t('about.team2D1')}}<span>{{$t('about.team2D2')}}</span>{{$t('about.team2D3')}}<span>{{$t('about.team2D4')}}</span>{{$t('about.team2D5')}}
        </div>
      </div>
      <div class="item">
        <span class="name">{{$t('about.teamN3')}}</span>
        <img src="~@/assets/image/about/team3.png">
        <div class="details">
          {{$t('about.team3D1')}}<span>{{$t('about.team3D2')}}</span>{{$t('about.team3D3')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle'
export default {
  name: 'about',
  components: {
    SectionTitle
  }
}
</script>

<style lang="less" scoped>
.team, .honor-wrap {
  background: #F2F2F2;
}
.team-wrap {
  display: flex;
  color: #464545;
  .item {
    width: 33.3%;
    text-align: right;
    span.name {
      font-size: 12px;
      font-weight: bold;
      color: #fff;
      background-color: #3780FF;
      padding: 10px 14px;
      line-height: 30px;
      margin-right: 8px;
      border-radius: 8px;
    }
    img {
      width: 100%;
    }
    .details {
      padding: 1rem 1.5rem;
      text-align: left;
      line-height: 30px;
    }
    span {
      color: #3780FF;
    }
  }
}
@media (max-width: 768px) {
  .team-wrap {
    flex-direction: column;
    .item {
      width: 100%;
      margin-bottom: 3rem;
    }
  }
}
</style>
